import React, { useState, useEffect, useMemo } from "react";
import { Card, Button, Input, CardContent, Box } from "@mui/material";
import { useAuthContext } from "../context/AuthContextProvider";
import { useWeb3Context } from "../context/UseWeb3Context";

const Admin = () => {
  const [data, setData] = useState({
    contractName: "",
    tokenSymbol: "",
    hiddenMetadataUrl: "",
    maxSupply: "",
  });
  const { bigBeyondContract } = useAuthContext();
  const { account, library } = useWeb3Context();

  const contract = useMemo(
    () => bigBeyondContract(library, account),
    [bigBeyondContract, library, account]
  );

  useEffect(() => {
    const getData = async () => {
      try {
        const contractName = await contract.name();
        const tokenSymbol = await contract.symbol();
        const hiddenMetadataUrl = await contract.hiddenMetadataUri();
        const maxSupply = await contract.maxSupply();
        setData({
          ...data,
          contractName,
          tokenSymbol,
          hiddenMetadataUrl,
          maxSupply,
        });
      } catch (err) {
        console.log(err);
      }
    };
    if (contract) {
      getData();
    }
  }, [contract]);

  const whitelistOpenHandler = () => {
    console.log("whitelist Open Handler");
  };

  const whitelistCloseHandler = () => {
    console.log("whitelist close Handler");
  };

  const preSaleOpenHandler = () => {
    console.log("PreSaleOpenHandler");
  };

  const preSaleCloseHandler = () => {
    console.log("preSaleCloseHandler");
  };

  const publicSaleOpenHandler = () => {
    console.log("publicSaleOpenHandler");
  };

  const publicSaleCloseHandler = () => {
    console.log("publicSaleCloseHandler");
  };

  const revealCollection = () => {
    console.log("revealCollection");
  };

  return (
    <React.Fragment>
      <Box
        sx={{
          width: "100%",
          border: "1px solid black",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1> Admin Settings Panel</h1>
        <Card sx={{ margin: "1rem", padding: { xs: "0.2rem", md: "1rem" } }}>
          <h2>Initial setup </h2>
          <CardContent>
            <table>
              <tbody>
                <tr>
                  <td>New Contract</td>
                  <td>
                    <Input type="text" value={data.contractName}></Input>
                  </td>
                  <td>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                    >
                      Update
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td>Token Name</td>
                  <td>
                    <Input></Input>
                  </td>
                </tr>
                <tr>
                  <td>Token Symbol</td>
                  <td>
                    <Input type="text" value={data.tokenSymbol}></Input>
                  </td>
                </tr>
                <tr>
                  <td>Hidden Metadata URI</td>
                  <td>
                    <Input type="text" value={data.hiddenMetadataUrl}></Input>
                  </td>
                </tr>
                <tr>
                  <td>Max Supply</td>
                  <td>
                    <Input type="text" value={data.maxSupply}></Input>
                  </td>
                </tr>
                <tr>
                  <td>Whitelist Sale price</td>
                  <td>
                    <Input></Input>
                  </td>
                </tr>
                <tr>
                  <td>Whitelist Sale Quantity</td>
                  <td>
                    <Input></Input>
                  </td>
                </tr>
                <tr>
                  <td>Pre-Sale price</td>
                  <td>
                    <Input></Input>
                  </td>
                </tr>
                <tr>
                  <td>Pre-Sale Quantity</td>
                  <td>
                    <Input></Input>
                  </td>
                </tr>
                <tr>
                  <td>Public-Sale price</td>
                  <td>
                    <Input></Input>
                  </td>
                </tr>
                <tr>
                  <td>Public-Sale Quantity</td>
                  <td>
                    <Input></Input>
                  </td>
                </tr>
              </tbody>
            </table>
          </CardContent>
        </Card>

        <Card sx={{ margin: "1rem", padding: { xs: "0.2rem", md: "1rem" } }}>
          <h2>Admin Actions </h2>
          <CardContent>
            <table>
              <tbody>
                <tr>
                  <td>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                      onClick={whitelistOpenHandler}
                    >
                      Whitelist open
                    </Button>
                  </td>
                  <td></td>
                  <td>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                      onClick={whitelistCloseHandler}
                    >
                      Whitelist close
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                      onClick={preSaleOpenHandler}
                    >
                      Pre-Sale open
                    </Button>
                  </td>
                  <td></td>
                  <td>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                      onClick={preSaleCloseHandler}
                    >
                      Pre-Sale close
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                      onClick={publicSaleOpenHandler}
                    >
                      Public-Sale open
                    </Button>
                  </td>
                  <td></td>
                  <td>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                      onClick={publicSaleCloseHandler}
                    >
                      Public-Sale close
                    </Button>
                  </td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      sx={{ textTransform: "capitalize" }}
                      onClick={revealCollection}
                    >
                      {" "}
                      Reveal Collection
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </CardContent>
        </Card>
      </Box>
    </React.Fragment>
  );
};

export default Admin;
